import { ContentSearch } from './ContentSearch';
export default ContentSearch;